// extracted by mini-css-extract-plugin
export default {"ModalAuth":"ModalAuth_ModalAuth__RXxfk","Modal-content-left":"ModalAuth_Modal-content-left__jAjhM","Modal-content-right":"ModalAuth_Modal-content-right__946Zt"};